import AppRoute from "./router/AppRoute";
import "./App.css";
import React, { useState, useEffect, useRef } from "react";
import PageLoader from "./components/PageLoader/PageLoader";
import AnimatedCursor from "react-animated-cursor"
import zIndex from "@mui/material/styles/zIndex";

function App() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setTimeout(() => {
      setLoading(false); 
    }, 2000); 
  }, []); 

  return (
    <>

      {loading ? (
        <PageLoader />
      ) : (
        <div>
          {" "}
          <AppRoute />
        </div>
      )}
    </>
  );
}

export default App;
